export default __webpack_public_path__ + "static/media/img.9f12c8fe.jpg";